import AnalyticsService from '../../services/analytics-service'
import { eventPageCategories } from '../../services/analytics-service/categories'
import { eventPageActions } from '../../services/analytics-service/actions'

export const searchButtonClickTracking = (location: string, fromDate: string, toDate: string) => {
    AnalyticsService.trackEvent({
        action: eventPageActions.landingPageActions.SEARCH_BUTTON,
        category: eventPageCategories.LANDING_PAGE,
        label: location + '@' + fromDate + '-' + toDate,
    })
}

export const mostPopularDestinationClickTracking = (destination: string) => {
    AnalyticsService.trackEvent({
        action: eventPageActions.landingPageActions.MOST_POPULAR_DESTINATION,
        category: eventPageCategories.LANDING_PAGE,
        label: destination,
    })
}

export const mostPopularCategoryClickTracking = (category: string) => {
    AnalyticsService.trackEvent({
        action: eventPageActions.landingPageActions.MOST_POPULAR_CATEGORY,
        category: eventPageCategories.LANDING_PAGE,
        label: category,
    })
}

export const searchSnippetClickTracking = (location: string, eventName: string) => {
    AnalyticsService.trackEvent({
        action: eventPageActions.searchResultPageActions.SEARCH_RESULT_SNIPPET,
        category: eventPageCategories.SEARCH_RESULT_PAGE,
        label: location + '@' + eventName,
    })
}

export const bookNowButtonClickTracking = (location: string, eventName: string, price: string) => {
    AnalyticsService.trackEvent({
        action: eventPageActions.detailPageActions.BOOKING_BUTTON,
        category: eventPageCategories.DETAIL_PAGE,
        label: location + '@' + eventName,
        value: price,
    })
}

export const trackTotalResultsCount = (totalResults: number, searchQuery: string) => {
    AnalyticsService.trackEvent({
        action: 'load_resultlist_total_count',
        category: 'srl_tfw',
        label: searchQuery,
        value: totalResults.toString(),
    })
}
